export const normalizeText = (text: string): string => {
    return text
        .toLowerCase()
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '');
};

const processFilterValue = (key: string, value: unknown): unknown => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    const textNormalizers = ['name', 'title'];
    const booleanFields = ['active', 'search_in_content', 'search_in_title'];

    if (textNormalizers.includes(key) && typeof value === 'string') {
        return normalizeText(value);
    }

    if (booleanFields.includes(key)) {
        return typeof value === 'boolean' ? value : value === 'true';
    }

    if (key === 'tags') {
        if (Array.isArray(value)) {
            return value;
        }
        if (typeof value === 'string') {
            return value.split(',').map((tag) => tag.trim());
        }
    }

    return value;
};

export const buildDocumentParams = (
    filters: Record<string, string> | undefined,
    organizationId: string,
    page: number,
): Record<string, unknown> => {
    const params: Record<string, unknown> = {
        page,
        page_size: 10,
        organization_id: organizationId,
    };

    if (!filters) {
        return params;
    }

    for (const [key, value] of Object.entries(filters)) {
        const processedValue = processFilterValue(key, value);

        if (processedValue !== null) {
            params[key] = processedValue;
        }
    }

    return params;
};
